import Fingerprint from "fingerprintjs2";

export const getFingerprintAsync = async (): Promise<string> => {
    const fingerprint = await Fingerprint.getPromise();

    return JSON.stringify(fingerprint);
};
